<template lang="pug">
  #itemsetting(role='tabpanel', aria-labelledby='item-tab')
    .col-xs-12
      .form-group
        label.h4.control-label(for='formdescription') フォームの説明
        p 入力したものが作成したフォーム上に表示されます。
        textarea#formdescription.form-control(v-model='form.form_description' rows='3' placeholder='このフォームに対する説明を表示させたい場合に説明文を入力してください')
    //フォームパーツ設定
    #form.row
      .col-xs-12
        h4 パーツ設定
        p
          | パーツ一覧からパーツをドラッグ＆ドロップで、フォームエリアに移動してください。
          br
          | フォームエリアに移動後、クリックすると編集できます。ドラッグ＆ドロップすると上下移動で並び替えができます。
      .col-xs-8
        h5 フォームエリア
        .form-area.panel-group.draganddrop(@dragover='partDragOver' @drop='partDrop' @dragstart='dragStart')
          draggable(v-model='form.item_list' @start='drag=true' @end='drag=false' :options='{ handle: `.sortHandle` }')
            itemDetail(v-for='(item, index) in form.item_list'
              :data.sync='item' :key='item.id' :index='index' v-on:remove='form.item_list.splice(index, 1)')
      // パーツ一覧
      itemSource
    //- .col-xs-12.customcodearea.initialhideparts
    //-   h4 カスタム設定
    //-   .form-group
    //-     label.h5.control-label(for='css') CSS
    //-     textarea#css.form-control(rows='5' placeholder='フォームパーツに設定した属性に対して、カスタマイズのためのCSSコードをここに追加できます。')
    //-   .form-group
    //-     label.h5.control-label(for='js') JavaScript
    //-     textarea#js.form-control(rows='5' placeholder='フォームパーツに設定した属性に対して、カスタマイズのためのJavaScriptコードをここに追加できます。')
    .col-xs-3
      .form-group
        h4 テーマカラー設定
        //カラーピッカー
        .input-group.colorpicker
          input.form-control.selectcolor(v-model='form.theme_color' type='text'
            v-bind:class='{invalid:$v.form.theme_color.$invalid}')
          i.fa.fa-eyedropper.input-group-addon(aria-hidden='true')
        span.error(v-show='$v.form.theme_color.$invalid')
          p(v-show='!$v.form.theme_color.colorcode') カラーコードが正しくありません
      h4 同意文設定
      .radio02
        input#radio02-01.radio02-input(type='radio' name='radio02' v-model='form.is_agree' value='1')
        label(for='radio02-01') する
        input#radio02-02.radio02-input(type='radio' name='radio02' v-model='form.is_agree' value='0')
        label(for='radio02-02') しない
    .col-xs-12
      h5 同意文
      .x_content
        //wysiwyg
        textarea.summernote(v-model='form.agree_text'
          v-bind:class='{invalid:$v.form.agree_text && $v.form.agree_text.$invalid}')
        span.error(v-show='$v.form.agree_text && $v.form.agree_text.$invalid')
          p(v-show='$v.form.agree_text && !$v.form.agree_text.required') 同意文は必須です
    .col-xs-12
      .setting-button
        //- a.customsmallbutton.btn.btn-info(href='#', type='button', data-toggle="modal", data-target="#previewmodal") プレビュー
        a.customsmallbutton.btn.btn-success(type='button' @click='save') 保&nbsp;存
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { colorcode } from '@/validators'
import { itemDetail, itemSource } from './part'
import { Loader, Message, Request, bus } from '@/service'
import { getItem } from './part/PartConfig'
import draggable from 'vuedraggable'

export default {
  name: 'formItem',
  props: ['data'],
  data () {
    return {
      form: this.data,
      partDraggingItem: null
    }
  },
  // ダイナミックバリデーション
  validations () {
    let definition = {
      form: {}
    }
    // カラーは固定
    definition.form.theme_color = { colorcode }
    // 同意文が必要な場合に必須
    if (this.form.is_agree === '1') {
      definition.form.agree_text = { required }
    }

    return definition
  },
  mounted () {
    // 子コンポーネントのドラッグ対象を親コンポーネントに保存する
    bus.$on('partDragStart', (item) => {
      this.partDraggingItem = item
    })
  },
  methods: {
    save () {
      let form = {
        form_description: this.form.form_description,
        theme_color: this.form.theme_color,
        items: JSON.stringify(this.form.item_list),
        is_agree: this.form.is_agree,
        agree_text: this.form.agree_text
      }
      this.$nextTick(() => { Loader.show() })
      Request.create(true).put('/form/' + this.data.id + '/items', form)
        .then((res) => {
          Message.success('更新しました')
          this.$nextTick(() => { Loader.hide() })
        }).catch((err) => {
          Message.error(err.response.data.message)
          this.$nextTick(() => { Loader.hide() })
        })
    },
    dragStart (e) {
      // 左のリストでドラッグ開始した場合
      // 並び替え時のイベントはアイテムを追加しない
      this.partDraggingItem = null
    },
    partDragOver (e) {
      // ドラッグ中にリスト上でうろうろしている場合
      e.preventDefault()
    },
    partDrop (e) {
      // 子コンポーネントでドラッグされている場合のみ実行
      if (this.partDraggingItem) {
        // 添付ファイルは一つまで
        if (this.partDraggingItem === 'file') {
          let fileExists = this.data.item_list.some((item) => {
            return item.type === 'file'
          })
          if (fileExists) {
            Message.error('添付ファイルは一つまでしか追加できません')
            return
          }
        }
        let item = getItem(this.partDraggingItem)
        this.data.item_list.push(item)
      }
    }
  },
  components: {
    itemDetail, itemSource, draggable
  }
}
</script>

<style lang="stylus">
//js,cssコード記述エリア（現状不使用）
.codetextarea
  resize: vertical
.customcodearea
    display: none

.draganddrop
  min-height: 400px
  padding-bottom: 20px

.panel-heading
  padding: 0px
.fa-item
  font-size: 150%
  color: #5a738e
  padding: 8px

.colorpicker
  z-index: 10
.colorpicker:after, .colorpicker:before
  display: none
.input-group-addon
  padding: 6px 16px
  cursor: pointer
  display: table-cell

.form-area
  padding: 10px
  border: 1px solid #ddd
  border-radius: 3px
  textarea
    resize: vertical
  .tick
    position: absolute
    margin-top: -31px
    margin-left: -2px
    font-size: 24px
  .btn-success, .btn-danger
    padding: 5px 30px
  .btn-success
    float: left
  .btn-danger
    float: right
  .form-table
    .fa.fa-check-square-o
      padding: 0

// カラーピッカーのアイコン
.fa-eyedropper
  font-size: 18px

// wysiwyg
#editor
  overflow: scroll
  min-height: 100px
  width: 90%
  background-color: #fff
  line-height: 20px
// デフォルト非表示パーツ
// .initialhideparts
//   display: none
.placeholderinput
  color: #999
</style>



// WEBPACK FOOTER //
// Item.vue?53e06183